import React from 'react';
import { Box, Typography } from '@mui/material';
import InsertChartOutlinedIcon from '@material-ui/icons/InsertChartOutlined';

const ORANGE = '#FF6900';

const NoDataAvailable = ({
    title = 'No data available yet',
    subtitle = 'Please check back later',
    sx = {},
}) => {
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            padding: '60px 20px',
            backgroundColor: 'var(--brand-surface, #fff)',
            borderRadius: '16px',
            border: `1px dashed ${ORANGE}4D`,
            width: '100%',
            ...sx,
        }}>
            <InsertChartOutlinedIcon style={{ fontSize: 56, color: ORANGE, opacity: 0.35, marginBottom: 16 }} />
            <Typography sx={{ fontSize: '18px', fontWeight: 700, color: '#052F44', mb: 1 }}>
                {title}
            </Typography>
            <Typography sx={{ fontSize: '14px', color: '#6B7280', maxWidth: 440 }}>
                {subtitle}
            </Typography>
        </Box>
    );
};

export default NoDataAvailable;
